import styles from "./category-menu.module.css";
import CategoryMenuItem from "./CategoryMenuItem";

interface CategoryMenuProps {
  categories: any[];
  onCategoryClick(typeId: number): void;
}

const CategoryMenu = (props: CategoryMenuProps): any => {
  const { onCategoryClick } = props;

  const handleItemClick = (typeId: number) => {
    onCategoryClick(typeId);
  };

  const categories = props.categories.map((cat: any) => {
    return (
      <CategoryMenuItem
        label={cat.labels[0]}
        onClickItem={handleItemClick}
        typeId={cat.id}
        expanded={cat.expanded}
        icon={cat.icon}
        color={cat.color}
        expandedLocked={cat.expandedLocked}
      />
    );
  });

  return (
    <div className={styles["container"]}>
      {categories}
      <div className={styles["bottom-item"]}></div>
    </div>
  );
};

export default CategoryMenu;
